import { DealListSort } from "@irati/types";
export var DATE = DealListSort.Date;
export var POPULARITY = DealListSort.Popularity;
export var SORT_OPTIONS = [
    { value: DATE, label: "perks.constants.sortOptions.date" },
    { value: POPULARITY, label: "perks.constants.sortOptions.popularity" }
];
export default { DATE: DATE, POPULARITY: POPULARITY, OPTIONS: SORT_OPTIONS };
